import {displayGithubReferencesTool} from '../components/github-reference-tool'

/**
 * Tools added here need no host callbacks, so the Mission Control bootstrap
 * can contribute them when a caller creates the daemon session, without the
 * call site listing them. Non-contributing paths avoid claiming the active-client
 * role merely by mounting; eligible interactive surfaces claim this catalog
 * immediately before dispatching explicit user input. Tools that require runtime
 * callbacks or adapters do not belong in this catalog.
 */
export const HOST_INDEPENDENT_CLIENT_TOOLS = [displayGithubReferencesTool] as const
